import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';

export interface IConnectionState {
    oAuthCode?: string;
}

export const initialState: IConnectionState = {};

const name = 'connection';

const connectionSlice = createSlice({
    initialState,
    name,
    reducers: {
        setOAuthCode(state, action: PayloadAction<string>) {
            state.oAuthCode = action.payload;
        },
    },
});

export const { setOAuthCode } = connectionSlice.actions;

export const connectionSelectors = {
    oAuthCode: (state: RootState) => state.connection.oAuthCode,
};

export default connectionSlice.reducer;
